// extracted by mini-css-extract-plugin
export default {"content":"popup_content__Ka+eX","span":"popup_span__-74O2","title":"popup_title__gnayt"};